export const DEFAULT_LABEL = 'Enter text here';
export const APPSTORE_LINK_DESC = 'Make text entry and TV control easier by downloading the Fire TV app.'
export const APP_LINK = 'https://getstarted.amazonfiretvapp.com'
export const MAX_RECONNECT = 5;
export const RECONNECT_RETRY_DELAY_IN_MS = 1000;
export const MAX_WAIT_FOR_CLIENT_IN_MS = 30000;

export enum ClientStatus {
    INITIALIZING,
    CONNECTED,
    DISCONNECTED,
    CONNECTING,
    RECONNECTING,
    AUTHENTICATION_FAILURE
}

export enum OverlayStatus {
    CONNECTING = "Connecting",
    AUTHENTICATION_FAILURE= "Failed to Connect",
    DISCONNECTED= "Not Connected",
}

export enum AWSRegion {
    US_EAST_1 = "us-east-1",
    US_WEST_2 = "us-west-2",
    EU_WEST_1 = "eu-west-1"
}

export enum InputType {
    TEXT = "text",
    PASSWORD = "password"
}

export enum FireTVLayoutType {
    STANDARD_KEYBOARD = "STANDARD_KEYBOARD",
    PASSWORD_KEYBOARD = "PASSWORD_KEYBOARD",
    NO_INPUT_KEYBOARD = "NO_INPUT_KEYBOARD"
}

// Key codes (Ref - https://lists.w3.org/Archives/Public/www-dom/2010JulSep/att-0182/keyCode-spec.html#fixed-virtual-key-codes)
export enum KeyCode {
    Enter = 13
}

export enum MobileOS {
    iOS,
    Android,
    Unknown
}